import { UserEntity } from 'user-identity-js/lib/entities';

export const getUserName = (user: UserEntity | undefined) => {
	if (!user) {
		return 'Unknown';
	}
	const name = user.firstName || '' + ' ' + user.lastName || '';
	return name.trim().length > 0 ? name : !!user.email ? user.email : 'Unknown';
};
